// Stub for config store - replace with actual implementation
export const useConfigStore = () => ({
  settings: {},
  extensions: [],
});

useConfigStore.getState = () => ({
  settings: {},
  extensions: [],
});
